// extracted by mini-css-extract-plugin
module.exports = {"Container":"style_Container__9xmDF","Spinner":"style_Spinner__2sfcK","HistList":"style_HistList__3YY9U","closeBasket":"style_closeBasket__2ryJr"};